import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  setHasReadFirstSectionInstructions,
  setHasReadRoundInsructions,
  setInstructions,
  setIsOnBreak,
  setShowInstructions
} from '../../../../redux/Slices/StartTestSlice/startFulTest';
import { useAppSelector } from '../../../../redux/store/hooks';
import Button from '../../../Common/Button';

const InstructionsPage = () => {
  const dispatch = useDispatch();
  const {
    instructions,
    currentSectionIndex,
    hasReadRoundInsructions,
    hasReadFirstSectionInstructions,
    currentSectionName
  } = useAppSelector(state => state.root.startFulltest);
  const round = useAppSelector(state => state.root.newTemplete[0]?.rounds[0]);
  const section = useAppSelector(
    state => state.root.newTemplete[0].rounds[0].sections
  );
  const handleClick = () => {
    if (hasReadFirstSectionInstructions && hasReadRoundInsructions) {
      dispatch(setIsOnBreak(false));
      dispatch(setShowInstructions(false));
    } else if (!hasReadRoundInsructions && !hasReadFirstSectionInstructions) {
      dispatch(setHasReadRoundInsructions(true));
      if (section[0].isInstructionAvailabe === false) {
        dispatch(setHasReadFirstSectionInstructions(true));
        dispatch(setShowInstructions(false));
      }
    } else if (hasReadRoundInsructions && !hasReadFirstSectionInstructions) {
      dispatch(setIsOnBreak(false));
      dispatch(setShowInstructions(false));
      dispatch(setHasReadFirstSectionInstructions(true));
    }
  };

  useEffect(() => {
    if (hasReadRoundInsructions && !hasReadFirstSectionInstructions) {
      dispatch(setInstructions(section[currentSectionIndex]?.instructions));
    } else if (hasReadFirstSectionInstructions && hasReadRoundInsructions) {
      dispatch(setInstructions(section[currentSectionIndex]?.instructions));
    }
  }, [hasReadRoundInsructions, hasReadFirstSectionInstructions]);

  return (
    <div className='flex h-full max-w-[822px] flex-col items-center justify-self-center overflow-y-auto p-2 px-5 text-base'>
      <p className='text-2xl font-medium text-blue_a12'>
        Section {currentSectionIndex + 1}
      </p>
      <p className='my-3 text-3xl font-semibold text-primary'>
        {currentSectionName}
      </p>
      {!hasReadRoundInsructions ? (
        <div
          className='prose prose-sm space-y-3 font-normal text-blue_a12'
          dangerouslySetInnerHTML={{ __html: round.instructions }}
        />
      ) : (
        <div
          className='prose prose-sm space-y-3 font-normal text-blue_a12'
          dangerouslySetInnerHTML={{
            __html: section[currentSectionIndex]?.instructions
          }}
        />
      )}
      <div className='self-end'>
        <Button
          handleClickBtn={handleClick}
          disabled={false}
          label='Start Test'
          variant='contained'
        />
      </div>
    </div>
  );
};

export default InstructionsPage;
